"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _js = require("../utils/js");
var _dayjs = _interopRequireDefault(require("dayjs"));
var _appendCss = _interopRequireDefault(require("../utils/appendCss"));
var _ManualVariant_css = _interopRequireDefault(require("./ManualVariant_css"));
class ManualVariant extends _react.default.Component {
  constructor(props) {
    super(props);
    (0, _appendCss.default)("arc_variant", _ManualVariant_css.default);
    this.html = document.querySelector("html");
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleHtmlClick = this.handleHtmlClick.bind(this);
    this.hide = this.hide.bind(this);
    this.updateLocation = this.updateLocation.bind(this);
    this.getFirstClickTime = this.getFirstClickTime.bind(this);
    this.state = {
      clickCount: 0,
      mouseIsDown: false,
      show: false,
      firstClickTime: null,
      variant: this.getCurrentVariantParam(),
      supportsPointerEvents: window.PointerEvent
    };
  }
  componentDidMount() {
    if (!window.ADCManualVariant) {
      window.ADCManualVariant = true;
      if (window.PointerEvent) {
        this.html.addEventListener("pointerdown", this.handleHtmlClick);
      } else {
        this.html.addEventListener("touchstart", this.handleHtmlClick);
      }
    }
  }
  componentWillUnmount() {
    if (window.ADCManualVariant) {
      if (window.PointerEvent) {
        this.html.removeEventListener("pointerdown", this.handleHtmlClick);
      } else {
        this.html.removeEventListener("touchstart", this.handleHtmlClick);
      }
      delete window.ADCManualVariant;
    }
  }
  getCurrentVariantParam() {
    const params = (0, _js.getURIQueryParams)();
    let result = "";
    if (params.variant) {
      result = decodeURIComponent(params.variant);
    }
    return result;
  }
  getFirstClickTime() {
    const currentTime = (0, _dayjs.default)();
    const diff = this.state.firstClickTime !== null ? currentTime.diff(this.state.firstClickTime) : 0;
    if (this.state.firstClickTime === null || diff > 3000) {
      return {
        shouldReset: true,
        nextTime: currentTime
      };
    }
    return {
      shouldReset: false,
      nextTime: this.state.firstClickTime
    };
  }
  handleHtmlClick() {
    const {
      shouldReset,
      nextTime
    } = this.getFirstClickTime();
    let nextCount;
    if (shouldReset || this.state.clickCount > 9) {
      nextCount = 1;
    } else {
      nextCount = this.state.clickCount + 1;
    }
    this.setState({
      clickCount: nextCount,
      firstClickTime: nextTime,
      show: nextCount === 10 || this.state.show
    });
  }
  handleInputChange(event) {
    const {
      name,
      value
    } = event.target;
    this.setState({
      [name]: value
    });
  }
  hide(event) {
    event.stopPropagation();
    this.setState({
      show: false
    });
  }
  updateLocation() {
    const search = window.location.search;
    let separator = "?";
    if (search.includes("&") || search.includes("?")) {
      separator = "&";
    }
    window.location.search = "".concat(search).concat(separator, "variant=").concat(this.state.variant);
  }
  render() {
    if (!this.state.show) return null;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "ManualVariant"
    }, /*#__PURE__*/_react.default.createElement("button", {
      tabIndex: "-1",
      "aria-hidden": "true",
      className: "ManualVariant-toggle",
      onClick: this.hide,
      type: "button"
    }, this.state.show ? "Hide" : "Show"), /*#__PURE__*/_react.default.createElement("input", {
      tabIndex: "-1",
      "aria-hidden": "true",
      className: "ManualVariant-input",
      name: "variant",
      onChange: this.handleInputChange,
      onKeyUp: event => {
        if (event.key.toString().toLowerCase() === "enter") {
          this.updateLocation();
        }
      },
      placeholder: "Comma-separated list. Ex: b,d,g",
      type: "text",
      value: this.state.variant
    }), /*#__PURE__*/_react.default.createElement("button", {
      tabIndex: "-1",
      "aria-hidden": "true",
      className: "ManualVariant-button",
      onClick: this.updateLocation,
      type: "button"
    }, "Change"));
  }
}
exports.default = ManualVariant;